/**
 * Session Handler - Web Version
 * Handles session invalidation errors
 */

import { createLogger } from '@ctrl-enter/tools/utils';

const logger = createLogger('web:session-handler');

// Track if we've already handled a session error to prevent loops
let sessionErrorHandled = false;
let lastErrorTime = 0;

export async function handleSessionErrorInline(error: unknown) {
  logger.warn('⚠️ [Session Error]', error);

  // Prevent handling the same error repeatedly (debounce 5 seconds)
  const now = Date.now();
  if (sessionErrorHandled && now - lastErrorTime < 5000) {
    logger.info('⏭️ [Session Handler] Session error already handled recently, skipping');
    return;
  }

  // Check if this is a "different device" error
  if (
    error &&
    typeof error === 'object' &&
    'body' in error &&
    error.body &&
    typeof error.body === 'object' &&
    'error' in error.body &&
    error.body.error === 'session_invalid'
  ) {
    logger.warn('🔄 [Session Handler] Session invalid error detected');

    // DON'T clear device ID - this causes infinite loop!
    // The server should accept the same device ID if tokens are valid

    // Mark as handled
    sessionErrorHandled = true;
    lastErrorTime = now;

    // Reset after 10 seconds
    setTimeout(() => {
      sessionErrorHandled = false;
    }, 10000);

    logger.info('✅ [Session Handler] Session error handled, waiting for token refresh');
  }
}
